import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '80px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'body',
};

export const TextItem: CSSObject = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'normal',
};

export const LinkItem: CSSObject = {
  color: 'beta.300',
  fontWeight: 'bold',
};
